import { Component } from '@angular/core';

@Component({
  selector: 'app-power-seller-rules',
  templateUrl: './power-seller-rules.component.html',
  styleUrls: ['./power-seller-rules.component.scss'],
})
export class PowerSellerRulesComponent {}
